export default "__VITE_ASSET__CY9HE7PZ__"